import React from 'react'
import LgyLink from 'app/components/util/lgy-link/LgyLink'
import { determineDocType } from '../common/AssignmentUtils'

const DocumentsUploadHistory = ({ correspondence, username, fetching, error, summaryPage, lin }) =>
  <div className='documents-upload-history'>
    <h3>Documents Upload History</h3>
    {summaryPage && <div className='appraiser-note'>
      The documents listed below and others can be viewed in <LgyLink to={`/lgyhub/appraiser/${lin}/correspondence`}>Correspondence History</LgyLink>.
      </div>}
    <div>{correspondence && correspondence.length ? correspondence.length : 0} Correspondence(s)</div>
    <table>
      <thead>
        <tr>
          <th scope='col'>Date Uploaded/ Generated</th>
          <th scope='col'>Document Type	</th>
          <th scope='col'>Document Name</th>
          <th scope='col'>Revision Comments</th>
          <th scope='col'>Corresp. Type</th>
          <th scope='col'>User Preparing Corresp.</th>
        </tr>
      </thead>
      <tbody>
        {fetching && <tr><td colSpan='6'>Loading correspondence history...</td></tr>}
        {error && <tr><td colSpan='6'>Error: Unable to load correspondence history.</td></tr>}
        {correspondence && correspondence.map(document =>
          <tr key={`${document.documentName}${document.createDate}`}>
            <td data-label='Date Uploaded / Generated:'>{document.createDate}</td>
            <td data-label='Document Type:'>
              {!summaryPage && <a
                href={`/lgyhub/WebLGY/VipEligibilityInterface.do?action=viewdoc&portalId=${username}&appName=Appraiser Portlet&CorrespondenceId=${document.appraisalCorrespondenceId}&sk=${document.securityKey}`}
                target='_blank' rel='noopener noreferrer'>
                {determineDocType(document.appraisalDocumentTypeId)}
              </a>}
              {summaryPage && determineDocType(document.appraisalDocumentTypeId)}
            </td>
            <td data-label='Document Name:'>{document.documentName}</td>
            <td data-label='Revision Comments:'>{document.freeText || 'N/A'}</td>
            <td data-label='Correspondence Type:'>{document.correspondenceTypeCode}</td>
            <td data-label='User Preparing Correspondence:'>{document.createUserName}</td>
          </tr>)}
      </tbody>
    </table>
  </div>

export default DocumentsUploadHistory
